import { Component, Vue } from "vue-property-decorator"
import { getMarketCooperationVisitByMarketCooperationId, setMarketCooperationVisit, uploadFile } from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { Loading } from "element-ui"
import axios from "axios";
import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({
    filters: {
        dataFilter: (val: string) => (formatDate('yyyy-MM-dd hh:mm', new Date(val)))
    }
})
export default class NewVisit extends Vue {
    /* data */
    id: number | undefined
    name = ''
    place = '' // 地点
    spend = '' // 花费
    date: Date = new Date()
    time = new Date().getHours().toString().padStart(2, '0') + ':00'
    explain = '' // 拜访的主要内容
    tableData: any[] = []
    page = 1
    limit = 20
    total = 0
    timePickerOptions = { start: '00:00', step: '01:00', end: "23:59" }
    axios = null
    loading = false
    signature = ''

    /* created() */
    created() {
        const query = this.$route.query
        if (query.id) {
            this.id = Number(query.id)
            this.name = query.name as string
            this.getTableData()
        }
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if(this.tableData.length >= this.total) {

                        return
                    }
                    this.limit += 20
                    this.getTableData()
                }
            }, true);
        })
        this.createAxios()
    }

    /* methods */

    createAxios() {
        const origin = location.hostname; //当前访问域名
        let requestBase = "";
        if (process.env.NODE_ENV === "development") {
            requestBase = process.env.VUE_APP_BASE_FILE_API_PROXY;
            // requestBase = process.env.VUE_APP_TESTFIELE_SEAVER_API;
        } else {
            if (origin.indexOf("-testserver") > -1) {
                requestBase = process.env.VUE_APP_DEV_FILE_API;
            } else {
                requestBase = process.env.VUE_APP_MASTER_FILE_API;
            }
        }
        const config = {
            baseURL: requestBase,
            timeout: 30 * 1000, // Timeout
        };
        this.axios = axios.create(config);
    }

    async getTableData() {
        this.loading = true
        await getMarketCooperationVisitByMarketCooperationId({
            marketCooperationId: this.id as number,
            page: this.page,
            limit: this.limit
        }).then((data: any) => {
            this.total = data.allNum
            this.tableData = data.marketCooperationVisitList.map((item: any) => ({...item, readonly: true}))
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }
    async setMarketCooperationVisit() {
        if (!(this.place && this.spend && this.date && this.time && this.explain)) {
            this.$message.error(`
                ${this.place ? '' : '拜访地点，'}
                ${this.spend ? '' : '花费金额，'}
                ${this.date ? '' : '拜访日期，'}
                ${this.time ? '' : '拜访时间，'}
                ${this.explain ? '' : '拜访主要内容'}
                不能为空
            `)
            return
        }
        await setMarketCooperationVisit({
            marketCooperationId: this.id,
            address: this.place,
            price: this.spend,
            visitAt: formatDate('yyyy-MM-dd', new Date(this.date)) + ' ' + this.time + ':00',
            content: this.explain,
        })
        this.$message.success("新建拜访记录成功")
        this.place = '' // 地点
        this.spend = '' // 花费
        this.date = new Date() // 日期
        this.time = new Date().getHours().toString().padStart(2, '0') + ':00' // 时间
        this.explain = '' // 拜访的主要内容
        this.getTableData()
    }

    async confirmRow(row: any) {
        const obj = {...row}
        obj.price = String(obj.price)
        obj.visitAt = this.dealdate(obj.visitAt)
        await setMarketCooperationVisit(obj)
        row.readonly = true
        // console.log(this.tableData.findIndex((item: any) => item.name === row.name ))
    }
    dealdate(dealdate) {
        const date = new Date(dealdate)
        const year = date.getFullYear()
        let month: string | number = date.getMonth() + 1
        month = month < 10 ? "0" + month : month
        let day: string | number = date.getDate()
        day = day < 10 ? "0" + day : day
        let hour: string | number = date.getHours()
        hour = hour < 10 ? "0" + hour : hour
        let minute: string | number = date.getMinutes()
        minute = minute < 10 ? "0" + minute : minute
        let second: string | number = date.getSeconds()
        second = second < 10 ? "0" + second : second
        return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    }

    async uploadFile(row: any, e: any) {
        const loading = Loading.service({ text: '正在上传文件' })
        const file = e.target.files[0]
        const formdata = new FormData()
        formdata.append('file', file, file.name)
        formdata.append('bucket', 'crm')
        this.signature = makeUploadSignature('crm', file.name)
        formdata.append('signature', this.signature)
        this.axios.post(
            "/upload/upload",
            formdata
        ).then(res => {
            const data: any = res.data.data
            row.enclosureList.push({
                name: data.name,
                url: data.ossUrl
            })
            this.$nextTick(() => {
                loading.close()
            })
        }).catch(error=>{
            console.log(error)
        })
    }
    delFile(row: any, index: number) {
        row.splice(index, 1)
    }

    inputspend(val){
        /*仅限输入数字，输入其他提醒*/
        if(isNaN(val)) {
            this.$message.warning('请输入数字')
            this.spend = ''
            return
        }
    }
    inputPrice(val){
        /*仅限输入数字，输入其他提醒*/
        if(isNaN(val)) {
            this.$message.warning('请输入数字')
            this.tableData.forEach(item=>{
                item.price = 0
            })
            return
        }
    }
}
